import {
  Table,
  Tr,
  Td,
  Tbody,
  Thead,
  Th,
  TableContainer,
  VStack,
  Text,
  HStack,
  Input,
  Button,
  Box,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useStores } from '../store/store_context';
import PanelModal from './panel_modal';
import { useEffect, useRef, useState } from 'react';
import PanelEditForm from './panel_forms/panel_edit_form';
import { deletePanelById, updatePanelById } from '../store/api_funcs';
import { MdDelete } from 'react-icons/md';

const PanelTable = ({
  panels,
  getTablePanels,
  usersForPanelForm,
  getTableUsers,
  group = false,
}) => {
  const { pageStore } = useStores();

  const PanelTableText = {
    RU: ['адрес', 'модель нейросети', 'номер', 'комментарий', 'разрешение'],
    EN: ['adress', 'model url', 'fabric number', 'comment', 'dimensions'],
  };
  function searchPanels(panels, searchParams) {
    setSearch(
      panels
        .filter(panel => {
          // Проверка поиска по адресу
          const matchAddress = searchParams.adress
            ? panel.adress
                .toLowerCase()
                .includes(searchParams.adress.toLowerCase())
            : true;

          // Проверка поиска по именам пользователей
          const matchUsernames = searchParams.usernames
            ? panel.usernames
                .toLowerCase()
                .includes(searchParams.usernames.toLowerCase())
            : true;

          // Возврат объекта панели, если он соответствует всем критериям
          return matchAddress && matchUsernames;
        })
        .map(panel => ({
          ...panel,
        }))
    );
  }

  // Пример вызова функции поиска
  const [adress, setAdress] = useState(false);
  const [usernames, setUsernames] = useState(false);
  const [search, setSearch] = useState([]);
  const [panelToDelete, setPanelToDelete] = useState(null);
  const [qrPanel, setQrPanel] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isQrOpen,
    onOpen: onQrOpen,
    onClose: onQrClose,
  } = useDisclosure();
  const cancelRef = useRef();
  const toast = useToast();
  const tableContainerProps = {
    width: '100%',
    border: '1px solid rgba(255,255,255,0.14)',
    borderRadius: '8px',
    backgroundColor: 'rgba(255,255,255,0.025)',
    overflow: 'hidden',
  };
  const rowProps = {
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    _hover: { backgroundColor: 'rgba(139,92,246,0.18)' },
  };
  const cellProps = {
    borderRight: '1px solid rgba(255,255,255,0.08)',
  };

  const requestDelete = panel_id => {
    setPanelToDelete(panel_id);
    onOpen();
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await deletePanelById(panelToDelete, pageStore.token);
      await getTablePanels();
      toast({
        title: 'Панель удалена',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: 'Не удалось удалить панель',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const panelQrLink = panel =>
    `https://t.me/IPANEL_podderzka_bot?start=device_${encodeURIComponent(
      String(panel?.fabric_number || ''),
    )}`;

  const panelQrUrl = panel =>
    `https://admin.i-panel.pro:8787/api/panels/qr/${encodeURIComponent(
      String(panel?.fabric_number || ''),
    )}.png`;

  const openQr = panel => {
    setQrPanel(panel);
    onQrOpen();
  };

  const downloadQr = async () => {
    if (!qrPanel) return;
    try {
      const link = document.createElement('a');
      link.href = `${panelQrUrl(qrPanel)}?download=1`;
      link.download = `ipanel_qr_${qrPanel.fabric_number || qrPanel.panel_id}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast({
        title: 'Не удалось скачать QR',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (!group) {
      getTablePanels();
    }
  }, []);
  useEffect(() => {
    if (panels != null) {
      searchPanels(panels, {
        adress: adress,
        usernames: usernames,
      });
      console.log(search);
    }
  }, [adress, usernames, panels]);
  return (
    <VStack width={'100%'} spacing={'20px'}>
      <Text fontSize={24} alignSelf={'flex-start'} color={'white'} fontWeight={700}>
        Поиск панелей
      </Text>
      <HStack width={'100%'}>
        <Input
          width={'20%'}
          placeholder="адрес панели"
          onChange={e =>
            e.target.value == '' ? setAdress(false) : setAdress(e.target.value)
          }
        ></Input>
        <Input
          width={'20%'}
          placeholder="никнейм владельца"
          onChange={e =>
            e.target.value == ''
              ? setUsernames(false)
              : setUsernames(e.target.value)
          }
        ></Input>
      </HStack>
      <TableContainer {...tableContainerProps}>
        <Table variant={'unstyled'}>
          <Thead>
            <Tr>
              <Th>{PanelTableText[pageStore.lang][0]}</Th>
              <Th>{PanelTableText[pageStore.lang][1]}</Th>
              <Th>{PanelTableText[pageStore.lang][2]}</Th>
              <Th>{PanelTableText[pageStore.lang][3]}</Th>
              <Th>{PanelTableText[pageStore.lang][4]}</Th>
              <Th width="78px" textAlign="center">QR</Th>
              <Th>Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {search !== null
              ? search.map(elem => {
                  return (
                    <Tr key={elem.panel_id} {...rowProps}>
                      <Td {...cellProps}>{elem.adress}</Td>
                      <Td {...cellProps}>
                        {elem.model_url}
                      </Td>
                      <Td {...cellProps}>
                        {elem.fabric_number}
                      </Td>
                      <Td
                        {...cellProps}
                        maxW={'300px'}
                        whiteSpace={'pre-line'}
                      >
                        {elem.comment}
                      </Td>
                      <Td {...cellProps}>
                        {elem.dimensions}
                      </Td>
                      <Td {...cellProps} width="78px" minW="78px" textAlign="center">
                        <Box
                          as="button"
                          type="button"
                          onClick={() => openQr(elem)}
                          border="1px solid rgba(255,255,255,0.18)"
                          borderRadius="8px"
                          padding="5px"
                          backgroundColor="white"
                          display="inline-flex"
                          alignItems="center"
                          justifyContent="center"
                          width="64px"
                          height="64px"
                          minW="64px"
                          overflow="hidden"
                          lineHeight={0}
                          _hover={{ transform: 'scale(1.04)' }}
                        >
                          <Image
                            src={panelQrUrl(elem)}
                            alt={`QR ${elem.fabric_number}`}
                            boxSize="54px"
                            minW="54px"
                            objectFit="contain"
                            display="block"
                          />
                        </Box>
                      </Td>
                      <Td>
                        <HStack>
                          <PanelModal>
                            <PanelEditForm
                              panel_id={elem.panel_id}
                              onSubmit={updatePanelById}
                              updatePanelsTable={getTablePanels}
                              usersForPanelForm={usersForPanelForm}
                              usernames={elem.usernames}
                              getTableUsers={getTableUsers}
                              panels={panels}
                            />
                          </PanelModal>
                          {!group ? (
                            <Button
                              aria-label="Удалить панель"
                              backgroundColor={'rgba(239,68,68,0.86)'}
                              color="white"
                              _hover={{ backgroundColor: '#E05A5A' }}
                              onClick={() => requestDelete(elem.panel_id)}
                            >
                              <MdDelete />
                            </Button>
                          ) : null}
                        </HStack>
                      </Td>
                    </Tr>
                  );
                })
              : null}
          </Tbody>
        </Table>
      </TableContainer>
      <Modal isOpen={isQrOpen} onClose={onQrClose} isCentered size="md">
        <ModalOverlay bg="rgba(0,0,0,0.72)" />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#1b1c2b'}
          color={'white'}
          border="1px solid rgba(255,255,255,0.16)"
        >
          <ModalHeader>
            QR панели {qrPanel?.fabric_number || '—'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <Box
                backgroundColor="white"
                padding="16px"
                borderRadius="10px"
                width="360px"
                height="360px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {qrPanel ? (
                  <Image
                    src={panelQrUrl(qrPanel)}
                    alt={`QR ${qrPanel.fabric_number}`}
                    boxSize="328px"
                    minW="328px"
                    objectFit="contain"
                    display="block"
                  />
                ) : null}
              </Box>
              <Text color="rgba(255,255,255,0.7)" fontSize="13px" wordBreak="break-all">
                {qrPanel ? panelQrLink(qrPanel) : ''}
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              backgroundColor={'#7A4CE0'}
              color="white"
              _hover={{ backgroundColor: '#8B5CF6' }}
              onClick={downloadQr}
            >
              Скачать QR
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent
            fontFamily={"'Jura', sans-serif"}
            backgroundColor={'#1b1c2b'}
            color={'white'}
          >
            <AlertDialogHeader>Удалить панель?</AlertDialogHeader>
            <AlertDialogBody>Действие нельзя отменить.</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Отмена
              </Button>
              <Button
                ml={3}
                colorScheme="red"
                isLoading={isDeleting}
                onClick={handleDelete}
              >
                Удалить
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </VStack>
  );
};

export default PanelTable;
